/* ==========================================================
   New selector (bundle options + free gifts)
   Needs jQuery, which is already loaded in layout/theme.liquid
   ========================================================== */

$(document).ready(function () {
  // Open the first "unlocked" gifts of the panel, lock the rest.
  function updateGifts($selector, $tier) {
    var unlocked = parseInt($tier.attr("data-unlocked"), 10);

    if (isNaN(unlocked)) {
      unlocked = 0;
    }

    $selector.find(".ns-gift-slot").each(function (index) {
      if (index < unlocked) {
        $(this).removeClass("ns-gift-slot--locked");
      } else {
        $(this).addClass("ns-gift-slot--locked");
      }
    });
  }

  // Show the price of the chosen option on the button.
  function updateButton($tier) {
    var price = $tier.find(".ns-tier__price-now").text().trim();
    $(".ns-atc").find(".ns-atc__price").text(price);
  }

  // Mark one option as chosen.
  // "active" is also added, because other theme scripts read it.
  function selectTier($tier) {
    var $selector = $tier.closest(".ns-selector");

    $selector.find(".ns-tier").removeClass("ns-tier--selected active");
    $tier.addClass("ns-tier--selected active");

    // Text under the button: show the line of the chosen option, in this buy box only.
    $tier
      .closest(".main_product-outer")
      .find(".ns-atc-note__tier")
      .removeClass("is-active")
      .filter('[data-index="' + $tier.attr("data-index") + '"]')
      .addClass("is-active");
    updateGifts($selector, $tier);
    updateButton($tier);
  }

  // Take the utm_ parameters from the address bar and put them on the link.
  function addUtms(url) {
    var parameters = window.location.search.replace("?", "").split("&");
    var utms = [];

    for (var i = 0; i < parameters.length; i++) {
      if (parameters[i].indexOf("utm_") === 0) {
        utms.push(parameters[i]);
      }
    }

    if (utms.length === 0) {
      return url;
    }

    // Use "?" when the link has no parameters yet, "&" when it already has some.
    var sign = url.indexOf("?") === -1 ? "?" : "&";

    return url + sign + utms.join("&");
  }

  // Countdown bar: counts down "data-minutes" and starts again at zero.
  // The end time is kept in localStorage, so a reload does not reset it.
  var timerInterval = null;
  var timerEndFallback = null;

  function getTimerEnd(minutes) {
    var end = null;

    try {
      end = parseInt(localStorage.getItem("ns-timer-end"), 10);
    } catch (e) {
      end = timerEndFallback;
    }

    if (!end || isNaN(end) || end <= Date.now() || end - Date.now() > minutes * 60000) {
      end = Date.now() + minutes * 60000;
      timerEndFallback = end;
      try {
        localStorage.setItem("ns-timer-end", end);
      } catch (e) {}
    }

    return end;
  }

  function pad(number) {
    return number < 10 ? "0" + number : String(number);
  }

  function startTimers() {
    clearInterval(timerInterval);

    var $timers = $(".ns-timer");
    if ($timers.length === 0) {
      return;
    }

    var minutes = parseInt($timers.first().attr("data-minutes"), 10) || 5;

    function tick() {
      var left = Math.max(0, getTimerEnd(minutes) - Date.now());
      var seconds = Math.floor(left / 1000);

      $timers.find('[data-ns-timer="h"]').text(pad(Math.floor(seconds / 3600)));
      $timers.find('[data-ns-timer="m"]').text(pad(Math.floor((seconds % 3600) / 60)));
      $timers.find('[data-ns-timer="s"]').text(pad(seconds % 60));
    }

    tick();
    timerInterval = setInterval(tick, 1000);
  }

  // Choose the option marked in the theme editor, or the first one.
  function start() {
    startTimers();

    $(".ns-selector").each(function () {
      var $selector = $(this);
      var $startTier = $selector.find(".ns-tier--selected").first();

      if ($startTier.length === 0) {
        $startTier = $selector.find(".ns-tier").first();
      }

      if ($startTier.length > 0) {
        selectTier($startTier);
      }
    });
  }

  // Click on an option.
  $(document).on("click", ".ns-tier", function () {
    selectTier($(this));
  });

  // Open the Kaching cart drawer after an item was added.
  function openCartDrawer() {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true })
    );

    if (window.kachingCartApi && window.kachingCartApi.openCart) {
      window.kachingCartApi.openCart();
      return;
    }

    if (window.Shopify && Shopify.actions && Shopify.actions.openCart) {
      Shopify.actions.openCart();
      return;
    }

    var cartLink = document.querySelector('a[href="/cart"], a[href$="/cart"]');
    if (cartLink) {
      cartLink.click();
    }
  }

  // Cart mode: add the chosen option to the cart, open the cart drawer and
  // remember its link, which the cart checkout button then goes to
  // (snippets/slidecart_redirect-tochamps.liquid).
  function addToCart($button) {
    if ($button.hasClass("is-loading")) {
      return;
    }

    // The top and bottom selectors have different links, so use the one of this section.
    var $tier = $button
      .closest(".main_product-outer")
      .find(".ns-tier--selected")
      .first();
    var url = $tier.attr("data-coc-url");

    if (url) {
      if (url.indexOf("://") === -1 && url.charAt(0) !== "/") {
        url = "https://" + url;
      }
      url = addUtms(url);
      window.nsCheckoutUrl = url;
      try {
        sessionStorage.setItem("ns-checkout-url", url);
      } catch (e) {}
    }

    $button.addClass("is-loading");

    function fail() {
      alert("Error adding item to the cart.");
      $button.removeClass("is-loading");
    }

    // Empty the cart first, so it holds only the chosen option.
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function () {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: { items: [{ id: $tier.attr("data-id"), quantity: 1 }] },
          dataType: "json",
          success: function () {
            $button.removeClass("is-loading");
            openCartDrawer();
          },
          error: fail,
        });
      },
      error: fail,
    });
  }

  // Click on the add to cart button: go to the link of the chosen option.
  $(document).on("click", ".ns-atc", function () {
    if ($(this).attr("data-cart-mode") === "true") {
      addToCart($(this));
      return;
    }

    var url = $(".ns-tier--selected").first().attr("data-coc-url");

    console.log("New selector: button link is", url);

    if (!url) {
      console.log(
        "New selector: the chosen option has no 'Add to cart button link' set."
      );
      return;
    }

    // Add https:// when the link was pasted without it, otherwise the browser
    // treats it as a page of this shop and nothing happens.
    if (url.indexOf("://") === -1 && url.charAt(0) !== "/") {
      url = "https://" + url;
    }

    window.location.href = addUtms(url);
  });

  start();

  // The theme editor rebuilds the section after every change, so start again.
  $(document).on("shopify:section:load", start);
});
